import * as FilterTypes from './FilterTypes';

export const SelectFilter = (data, filter) => {
  if (filter != undefined) return filter;
  else if (!isNaN(Number(data))) return FilterTypes.NUMERIC_FILTER;
  else return FilterTypes.STRING_FILTER;
};
